import React, { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Box, Button, TextField, Typography, Alert } from '@mui/material';
import createAuthService from '../../utils/AuthService';
import { useAppContext } from '../../contexts/AppContext';
import { useLanguage } from '../../contexts/LanguageContext'; // ✅ import language

function ChangePassword() {
  const [searchParams] = useSearchParams();
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const { updateAppState } = useAppContext();
  const { translations } = useLanguage(); // ✅ translations

  const authService = createAuthService();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    const email = searchParams.get('email');
    const token = searchParams.get('token');

    if (!email || !token) {
      setError(translations.auth_pages.invalid_token);
      return;
    }

    if (newPassword !== confirmPassword) {
      setError(translations.auth_pages.passwords_do_not_match);
      return;
    }

    const response = await authService.updatePasswordAsync(email, newPassword, token);

    if (response.status !== 200) {
      setSuccess(false);
      setError(response.message);
      return;
    }

    setSuccess(true);
    updateAppState({
      isAuthenticated: true,
      accessToken: response.data.accessToken,
      refreshToken: response.data.refreshToken,
    });

    const meResponse = await authService.meAsync(response.data.accessToken);
    if (meResponse.status === 200) {
      updateAppState({ user: meResponse.data });
    }
  };

  return (
    <Box sx={{ maxWidth: 400, margin: 'auto', mt: 10, p: 3, textAlign: 'center' }}>
      {!success ? (
        <>
          <Typography variant="h5" gutterBottom>
            {translations.auth_pages.reset_password_title}
          </Typography>
          <form onSubmit={handleSubmit}>
            <TextField
              required
              fullWidth
              margin="normal"
              label={translations.auth_pages.new_password}
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
            />
            <TextField
              required
              fullWidth
              margin="normal"
              label={translations.auth_pages.confirm_new_password}
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
            {error && (
              <Alert severity="error" sx={{ mt: 2 }}>
                {error}
              </Alert>
            )}
            <Button type="submit" fullWidth variant="contained" sx={{ mt: 2 }}>
              {translations.auth_pages.reset_password_title}
            </Button>
          </form>
        </>
      ) : (
        <>
          <Alert severity="success" sx={{ mb: 2 }}>
            {translations.auth_pages.password_updated_successfully}
          </Alert>
          <Button variant="contained" sx={{ mt: 2 }} onClick={() => navigate('/home')}>
            {translations.auth_pages.go_to_home}
          </Button>
        </>
      )}
    </Box>
  );
}

export default ChangePassword;
